import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {
    searchShopifyProductPriceSyncsWithSearchCriteria
} from "../../services/shopify-product-price-sync-data.service";
import ShopifyProductPriceSyncFilters from "./shopify-product-price-sync-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {
    SHOPIFY_PRODUCTS_PRICE_FIELDS_LIST,
    SHOPIFY_PRODUCT_PRICE_SYNC_FIELDS_LIST
} from "../../constants/shopify-product-price-sync.constant";
import {showDateTime} from "../../../printful/utils/printful-util";
import ProductPriceList from "./product-price-list";
import {
    getShopifyProductPricesSyncStatus,
    initiateShopifyProductPriceSync,
} from "../../../common/services/cloud-function-service";

const defaultFilterCriteria: any = {};

const ShopifyProductPriceSyncsList = () => {
    const [shopifyProductPriceSyncsList, setShopifyProductPriceSyncsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getShopifyProductPriceSyncList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const shopifyProductPriceSyncListResult = await searchShopifyProductPriceSyncsWithSearchCriteria(searchCriteriaList);

        shopifyProductPriceSyncListResult?.forEach((shopifyProductPriceSync, index) => {
            if (index === 0) {
                shopifyProductPriceSync.showProductPrices = true;
            }
        });

        setShopifyProductPriceSyncsList(shopifyProductPriceSyncListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getShopifyProductPriceSyncList();
    }, [filterCriteria]);

    const refreshShopifyProductPriceSyncList = async () => {
        await getShopifyProductPriceSyncList();
    }

    const startProductPriceSyncProcess = async (productPriceSyncId) => {
        setDataFetchInProgress(true);
        const response = await initiateShopifyProductPriceSync(productPriceSyncId);

        await getShopifyProductPriceSyncList();
        setDataFetchInProgress(false);
    }

    const getLatestProductPriceSyncStatus = async () => {
        setDataFetchInProgress(true);
        const response = await getShopifyProductPricesSyncStatus();

        await getShopifyProductPriceSyncList();
        setDataFetchInProgress(false);
    }

    const toggleShowProductPrices = (shopifyProductPriceSync) => {
        const existingShopifyProductPriceSyncsList = [...shopifyProductPriceSyncsList];
        const index = _.findIndex(existingShopifyProductPriceSyncsList, {id: shopifyProductPriceSync.id});
        existingShopifyProductPriceSyncsList[index].showProductPrices = !existingShopifyProductPriceSyncsList[index].showProductPrices;

        setShopifyProductPriceSyncsList(existingShopifyProductPriceSyncsList);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Shopify Products Price Sync
                    </div>

                    {/*<ShopifyProductPriceSyncFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div className="ml-2">
                        <button
                            className="button-gray px-4 py-2 flex items-center justify-center"
                            onClick={getLatestProductPriceSyncStatus}>
                            <span>Get Latest Product Price Sync Status</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={shopifyProductPriceSyncsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Shopify Products Price Syncs'}/>

                    {shopifyProductPriceSyncsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {SHOPIFY_PRODUCT_PRICE_SYNC_FIELDS_LIST?.map((shopifyProductPriceSyncField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${shopifyProductPriceSyncField?.cssClass}`}>{shopifyProductPriceSyncField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {shopifyProductPriceSyncsList?.map((shopifyProductPriceSync, rowIndex) => (
                                <React.Fragment key={`row-${rowIndex}`}>
                                    <tr className="border border-gray-400">
                                        <td className="p-2 border border-gray-400 m-auto">
                                            <div className="flex justify-center w-12">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        {SHOPIFY_PRODUCT_PRICE_SYNC_FIELDS_LIST?.map((shopifyProductPriceSyncField, columnIndex) => (
                                            <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                                <td className={`p-2 border border-gray-400 m-auto ${shopifyProductPriceSyncField?.cssClass}`}>
                                                    {shopifyProductPriceSyncField?.optionsMap &&
                                                        <>{shopifyProductPriceSyncField?.optionsMap[shopifyProductPriceSync[shopifyProductPriceSyncField?.attribute]]?.name}</>
                                                    }

                                                    {!shopifyProductPriceSyncField?.optionsMap &&
                                                        <>
                                                            {!shopifyProductPriceSyncField?.isDate &&
                                                                <>
                                                                    {shopifyProductPriceSync[shopifyProductPriceSyncField?.attribute]}
                                                                </>
                                                            }

                                                            {shopifyProductPriceSyncField?.isDate &&
                                                                <>
                                                                    {showDateTime(shopifyProductPriceSync[shopifyProductPriceSyncField?.attribute])}
                                                                </>
                                                            }

                                                            {shopifyProductPriceSyncField?.secondaryAttribute &&
                                                                <div className={'text-gray-500 text-sm'}>
                                                                    {shopifyProductPriceSync[shopifyProductPriceSyncField?.secondaryAttribute]}
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        ))}

                                        <td className="p-2 border border-gray-400 m-auto w-60">
                                            <div className="flex justify-center">
                                                {shopifyProductPriceSync?.status === 'NEW' && shopifyProductPriceSync?.total > 0 &&
                                                    <div className="">
                                                        <button
                                                            className="button-green px-4 py-1 flex items-center justify-center"
                                                            onClick={() => {
                                                                startProductPriceSyncProcess(shopifyProductPriceSync.id)
                                                            }}>
                                                            <span>Start Price Sync Process</span>
                                                        </button>
                                                    </div>
                                                }

                                                <div className="">
                                                    <button
                                                        className={`px-4 py-1 flex items-center justify-center ${shopifyProductPriceSync?.showProductPrices ? 'button-purple-outline' : 'button-gray-outline '}`}
                                                        onClick={() => {
                                                            toggleShowProductPrices(shopifyProductPriceSync)
                                                        }}>
                                                        {shopifyProductPriceSync?.showProductPrices ? 'Hide Products' : 'Show Products'}
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    {shopifyProductPriceSync?.showProductPrices &&
                                        <tr className="border border-gray-400">
                                            <td colSpan={SHOPIFY_PRODUCTS_PRICE_FIELDS_LIST?.length}
                                                className={'p-4 bg-gray-100'}>
                                                <ProductPriceList
                                                    productPrices={_.values(shopifyProductPriceSync?.productPrices)}/>
                                            </td>
                                        </tr>
                                    }

                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default ShopifyProductPriceSyncsList
